//
import Model from '@/models/Model'
import SlDetailSaleInvoice from '@/models/Sale/SlDetailSaleInvoice'

/**
* This class describes a sl sale invoice.
* @class      SlSaleInvoice (name)
*/
export default class SlSaleInvoice extends Model {

  /**
   * { item_description }
   */
  static appends = [
    'account_receivable',
  ]

  /**
   * { item_description }
   */
  static includes = [
    'sl_service_order_as_affected',
    'sl_service_order_as_new',
    'sl_customer_account_movement',
    'sl_customer',
    'sl_customer_branch_offices',
    'sl_detail_sale_invoices',
    'g_company',
    'g_state',
    'first_pos_sale.g_seller_user.hr_employee',
  ]

  /**
   * { item_description }
   */
  SII_DOCUMENTS = [
    {
      code: 33,
      name: 'Factura Electrónica',
    },
    {
      code: 39,
      name: 'Boleta Electrónica',
    },
    {
      code: 61,
      name: 'Nota de crédito',
    },
  ]

  /**
   * { property_description }
   * @type       {<type>}
   */
  get documentType() {
    try {
      let { dte_type_invoice } = this
      let foundDocument = this.SII_DOCUMENTS.filter(item => {
        if (dte_type_invoice === item.code) {
          return item
        }
      })
      return foundDocument ? foundDocument[0].name : ''
    } catch (e) {
      return `e: ${e}`
    }
  }

  /**
   * { property_description }
   * @type       {string}
   */
  get payDate() {
    try {
      let { pay_date } = this.account_receivable
      if (pay_date !== null || pay_date !== '') return pay_date
    } catch (e) {
      return `-`
    }
  }

  /**
   * { property_description }
   * @type       {string}
   */
  get realPayDate() {
    try {
      let { real_pay_date } = this.account_receivable
      if (real_pay_date !== null || real_pay_date !== '')
        return real_pay_date
    } catch (e) {
      return `-`
    }
  }

  /**
   * { property_description }
   * @type       {string}
   */
  get amountSaleInvoice() {
    try {
      let { amount } = this.account_receivable
      if (amount !== null || amount !== '')
        return amount
    } catch (e) {
      return `e: ${e}`
    }
  }

  /**
   * { property_description }
   * @type       {string}
   */
  get paidAmount(){
    try {
      let { paid_amount } = this.account_receivable
      if (paid_amount !== null || paid_amount !== '')
        return paid_amount
    } catch (e) {
      return `e: ${e}`
    }
  }

  //get g_seller_user_name_case() {
  //  return this.getProperty('first_pos_sale.g_seller_user.hr_employee.name_case', '-')
  //}

  /**
   * Returns a pdf representation of the object.
   *
   * @return     {Promise}  Pdf representation of the object.
   */
  //toPdf() {
  //  return this.pdf().then(this.showFile(this.file_name, 'pdf'))
  //}

  /**
   * { property_description }
   * @type       {string}
   */
  get balanceSaleInvoice(){
    try {
      let { balance } = this.account_receivable
      if (balance !== null || balance !== '')
        return balance
    } catch (e) {
      return `e: ${e}`
    }
  }   

  /**
   * { property_description }
   * @type       {<type>}
   */
  get g_state_name() {
    return this.getProperty('g_state.state', '-')
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get g_seller_user_name_case() {
    return this.getProperty('first_pos_sale.g_seller_user.hr_employee.name_case', '-')
  }

  /**
   * The file name
   * @type       {string}
   */
  get file_name() {
    return `FACTURA_VENTA_${this.number}`
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_branch_offices_address() {
    return this.getProperty('sl_customer_branch_offices.address', '-')
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_business_name() {
    return this.getProperty('sl_customer.business_name', '-')
  }

  /**
   * { lambda_description }
   * @param      {<type>}  item    The item
   */
  mapDetail = item => {
    return new SlDetailSaleInvoice(item)
  }

  /**
   * { function_description }
   * @param      {<type>}  res     The resource
   * @return     {<type>}  { description_of_the_return_value }
   */
  mapPdf = res => {
    return this.showFile(this.file_name, 'pdf').call(this, res)
  }

  /**
   * Resets the object.
   * @return     {Object}  { description_of_the_return_value }
   */
  reset() {

    //
    this.sl_detail_sale_invoices = this.getProperty('sl_detail_sale_invoices', []).map(this.mapDetail)
    
    //
    return this
  }

  /**
   * { function_description }
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'sl_sale_invoice'
  }

  /**
   * Returns a pdf representation of the object.
   * @return     {Promise}  Pdf representation of the object.
   */
  toPdf = () => {
    return this
      .pdf()
      .then(this.mapPdf)
  }
}
